export interface IRingMaterial {
  name:string,
  purities:('9ct'|'14ct'|'18ct'|'500'|'600'|'925'|'950')[]
}

export const RING_MATERIALS:IRingMaterial[] = [
  {
    name: 'Yellow Gold',
    purities: ['9ct', '14ct', '18ct']
  },
  {
    name: 'White Gold',
    purities: ['9ct', '14ct', '18ct']
  },
  {
    name: 'Rose Gold',
    purities: ['9ct', '14ct', '18ct']
  },
  {
    name: 'Platinum',
    purities: ['600', '950']
  },
  {
    name: 'Palladium',
    purities: ['500', '950']
  },
  {
    name: 'Sterling Silver',
    purities: ['925']
  },
  {
    name: 'Titanium',
    purities: []
  },
  {
    name: 'Zirconium Grey',
    purities: []
  },
  {
    name: 'Zirconium Black',
    purities: []
  },
  {
    name: 'Tantalum',
    purities: []
  },
  {
    name: 'Carbon Fiber',
    purities: []
  }
]

//Materials which only come in one variant and have no surface or purity options
export const LIMITED_MATERIALS = ['Carbon Fiber'];

export class ringMaterialHelper {
  //generates a threngine material name from a ring's material name and surface name
  public static getMaterialName = (material:string, surface:string):string => {
    if (LIMITED_MATERIALS.includes(material)) {
      return `${material} MATCAP`
    } else {
      return `${material} ${surface} MATCAP`
    }
  }
};